/** @format */

import React, { useMemo } from "react";
import { Link, useLocation } from "@reach/router";
import { useTranslation } from "react-i18next";

const ROUTE_LABELS = {
  "": "Home",
  "/": "Home",
  sharingpoints: "mainsidebar.sharingpoints.label",
  "system-summary": "mainsidebar.systemSummary.label",
  batteries: "mainsidebar.batteries.label",
  "battery-data-ids": "mainsidebar.batteries.batteryDataIds",
  locations: "mainsidebar.locations.label",
  users: "Users",
  profile: "My profile",
  "release-notes": "mainsidebar.releaseNotes.label",
  swaps: "Swaps",
  "user-groups": "User groups",
  "swobbee-locations": "Public locations",
  create: "Create",
  edit: "Edit",
  settings: "Settings",
  notes: "Notes",
  files: "Files",
  interactions: "Interactions",
  "error-history": "Error history",
  reservations: "Reservations",
};

const decodeSegment = (segment) => {
  try {
    return decodeURIComponent(segment || "");
  } catch {
    return segment || "";
  }
};

const formatSegment = (segment) => {
  const decoded = decodeSegment(segment);
  if (!decoded) return "";
  if (decoded.length > 20) return `${decoded.slice(0, 8)}…`;
  return decoded;
};

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const items = useMemo(() => {
    const path = pathname.replace(/^\//, "") || "";
    const segments = path ? path.split("/").filter(Boolean) : [];

    const result = [
      { path: "/", label: "Home", active: segments.length === 0 },
    ];

    let accumulated = "";
    segments.forEach((segment, i) => {
      accumulated += `/${segment}`;
      const isLast = i === segments.length - 1;
      let label = ROUTE_LABELS[segment];
      if (label && label.startsWith("mainsidebar.")) {
        label = t(label);
      }
      if (!label) {
        label = formatSegment(segment);
      }
      result.push({
        path: accumulated,
        label: label || decodeSegment(segment),
        active: isLast,
      });
    });

    return result;
  }, [pathname, t]);

  if (items.length <= 1) {
    return (
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <span className="breadcrumbs__current">{items[0]?.label}</span>
      </nav>
    );
  }

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumbs__list">
        {items.map((item, i) => (
          <li key={item.path || i} className="breadcrumbs__item">
            {i > 0 && (
              <span className="breadcrumbs__divider" aria-hidden="true">
                /
              </span>
            )}
            {item.active ? (
              <span className="breadcrumbs__current">{item.label}</span>
            ) : (
              <Link to={item.path} className="breadcrumbs__link">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
